import React, { type ReactElement } from 'react';

import classNames from 'classnames';
import numeral from 'numeral';

export interface DiscountProps {
  price: number;
  className?: string;
}

export default function Discount({
  price,
  className,
}: DiscountProps): ReactElement {
  return (
    <span className={classNames('text-xs line-through ', className)}>
      {`${numeral(price).format('0,0')}\u00a0`}
    </span>
  );
}
